import RoleService from "../../../services/roles/RoleService";
import permissionService from "../../../services/permissions/permissionService";
import i18n from "../../../i18n/index";

export default {
    data() {
        return {
            read: false,
            selected: false,
            write: false,
            hiddenList: false,
            hideList: false,
            edit: false,
            delete: false,
            roleItems: [],
            permissionItems: [],
            loading: false,
            loadingDelete: false,
            selectedRole: "",
            selections: [],
            roleName: "",
            search: '',
            switch1: true,
            chkEstadoRol: false,
            headers: [{
                text: i18n.t('headers.role-name'),
                sortable: false,
                value: "groupName"
            }, {
                text: i18n.t('headers.role-state'),
                sortable: false,
                value: "groupName"
            }],
            itemsData: [{
                groupName: "Admin",
                modules: "Todos",
                submodules: "pedidos"
            }]
        };
    },
    props: {},
    watch: {
        selectedRole() {
            this.getPermissions();
        }
    },
    created() {
        this.searchRoles();
        this.getRoles();
    },
    methods: {
        getRoles() {
            RoleService.getRoles().then(response => {
                this.roleItems = response.data;
            });
        },

        getPermissions() {
            if (!this.selectedRole) return;

            this.permissionItems = [];
            this.selections = [];

            permissionService.getPermissions(this.selectedRole).then(result => {
                this.permissionItems = result.data;

                this.selections = this.permissionItems.flatMap(({ children }) => {
                    if (children)
                        return children.filter(child => child.have_permission === 1);
                    return;
                });
            });
        },
        saveRole() {
            if (this.roleName && this.roleName !== "") {
                const id = this.itemsData.length + 1;
                RoleService.createRole(this.roleName, id)
                    .then(response => {
                        this.searchRoles();
                        this.hiddenList = !this.hiddenList;
                    })
                    .catch(err => {
                        throw err;
                    });
            } else alert(i18n.t('enter-the-role'));
        },
        savePermissions() {
            if (!this.selections || this.selections.length === 0) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("permission.no-options-selected-error")
                });
                return;
            }

            let optionIds = Array.from(
                new Set(
                    this.selections.flatMap(item => {
                        return [item.id, item.parentId];
                    })
                )
            ).filter(id => id !== null);

            this.loading = true;

            permissionService
                .savePermissions({ roleId: this.selectedRole, options: optionIds })
                .then(response => {
                    this.loading = false;
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: i18n.t("permission.permissions-succesful-updated")
                    });
                    this.hiddenList = false;
                    this.selectedRole = false;
                    this.permissionItems = [];
                    this.selections = [];
                })
                .catch(error => {
                    this.loading = false;
                });
        },
        onRowClick(item) {
            this.hiddenList = !this.hiddenList;
            this.selectedRole = false;
            this.permissionItems = [];
            this.selections = [];
            this.selectedRole = item.id;
            this.chkEstadoRol = item.active;
        },
        searchRoles() {
            RoleService.getRoles().then(data => {
                this.itemsData = data.data;
            });
        },
        searchOneRole() {
            RoleService.getOneRole(this.search).then(data => {
                this.itemsData = "";
                this.itemitemsDatasData.push(data.data);
            });
        },
        closeRole() {
            this.hiddenList = !this.hiddenList;
            this.selectedRole = false;
            this.permissionItems = [];
            this.selections = [];
        },
        deleteRole() {
            let data = { id: this.selectedRole };
            this.loadingDelete = true;
            //console.log(data);
            RoleService.removeRole(data).then(result => {
                if (result.status == 200) {
                    this.loadingDelete = false;
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: "Rol Desactivado"
                    });
                    this.searchRoles();
                    this.closeRole();
                }
            }).catch(error => {
                this.loadingDelete = false;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: error.code
                });
                this.chkEstadoRol = true;
            })
        },
        changeEstado() {
            let data = { id: this.selectedRole };
            if (this.chkEstadoRol == false) {
                RoleService.desactiveRole(data).then(result => {
                    if (result.status == 200) {
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: "Rol Desactivado"
                        });
                        this.searchRoles();
                        this.closeRole();
                    }
                }).catch(error => {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: error.code
                    });
                    this.chkEstadoRol = true;
                })
            } else {
                RoleService.activeRole(data).then(result => {
                    if (result.status == 200) {
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: "Rol Activado"
                        });
                        this.searchRoles();
                        this.closeRole();
                    }
                }).catch(error => {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: error.code
                    });
                    this.chkEstadoRol = true;
                })
            }
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase()
            return items.filter(row => filter(row["name"], search));
        }
    }
};